<button class="btn btn-sm btn-link"
        (click)="onCancel()">Cancel all</button>